/* eslint-disable import/no-cycle */
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useProductPlatformStore = defineStore('productPlatform', () => {
    const isComponentInPp = ref(false);
    const setIsComponentInPp = (_isComponentInPp: boolean) => {
        isComponentInPp.value = _isComponentInPp;
    };

    return {
        isComponentInPp,
        setIsComponentInPp,
    };
});
